import React, { createContext, useState } from 'react'
import { UserJourneyList } from './UserJourneyList';


interface ListContextValue {
  isallChecked: boolean;
  setIsallChecked: (loggedIn: boolean) => void;
}
export const userListContext = createContext<ListContextValue>({
  isallChecked:false,
  setIsallChecked:() => {}
})
export const UserListContext = () => {
  const [isallChecked,setIsallChecked] = useState(false)
  return (
  <userListContext.Provider value={{isallChecked,setIsallChecked}} >
  <UserJourneyList/>
  </userListContext.Provider>
  )
}
